import React from 'react'
import { Link } from 'react-router-dom'
import { IMAGES } from '../utils/images'

const SignUp_Page_1 = () => {
  return (
         <div className="outlet-render">
    <div className="signup-main-container">
      <div className="signup-left-container">
        <h1 className="signup-heading">Welcome Back</h1>
        <h2 className="signup-title">Create free account</h2>
     
        <label className="signup-label">Enter OTP</label>
        <input
          className="signup-input"
          type="number"
          placeholder="Enter OTP"
        />

               <button className="signup-button">Next</button>
                <p className="privacy">By signing up, you agree to our Terms of Use and Privacy Policy.</p>
        
                <h2 className="signup-login-button">
                  Already have an account?<Link to="/signin"><button> Log in</button></Link>
                </h2>
          

    </div>
    <div className="singup-right-container">
                <img src={IMAGES.SIGNIN_MAIN} alt="signup image" />
              </div>
    </div>
    </div>
  )
}

export default SignUp_Page_1